<template>
  <div id="bericht">
    <!-- <UserInputToStation /> -->
  </div>
</template>

<script>
// import UserInputToStation from "@/components/UserInputToStation.vue";
export default {
  name: "Bericht",
  components: {
    // UserInputToStation,
  },
};
</script>

<style lang="scss" scoped>
#bericht { 
  margin-top: 20px;
  margin: auto;
  max-width: 768px;
  width: 100%;
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #component {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #component {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #component {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #component {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #component {
       
    }
}
</style>